<template>
  <ImageGallery v-model:current-image="currentImage" :images="images" />
</template>

<script setup lang="ts">
import { computed, ref, type Ref } from 'vue';
import ImageGallery from '@/pages/ProductPage/partials/ProductDetailPage/ImageGallery.vue';

const images = computed(() => Object.values(window.gallery_images));
const currentImage: Ref = ref(images.value[0] ?? undefined);
</script>
